import React, { useState, useEffect } from "react";
import Chat from "../components/common/Chat";
import Toolbar from "../navigation/Toobar";
import Header from "../layout/Header";
import { type } from "@testing-library/user-event/dist/type";

function BettingRecord(){
    const [selected, setSelected] = useState({
  name: "ALL",
  icon: "/icon/all.svg",
  type: "ALL",
});

  const [providers, setProviders] = useState([]);
  const [gameTypes, setGameTypes] = useState([]);
  const [bettingRecords, setBettingRecords] = useState([]);
  const [exchangeRecords, setExchangeRecords] = useState([]);
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [summary, setSummary] = useState({
    totalBets: 0,
    totalBetAmount: 0,
    totalWinAmount: 0,
    netProfitLoss: 0,
  });

const menus = [
  { name: "ALL", icon: "/icon/all.svg", type: "ALL" },
  { name: "Cricket", icon: "/icon/cricket.svg", type: "EXCHANGE" },
  { name: "Live Casino", icon: "/icon/ld.svg", type: "LIVE" },
  { name: "Slot Games", icon: "/icon/rng.svg", type: "SLOT" },
  { name: "Table Games", icon: "/icon/table.svg", type: "TABLE" },
  { name: "Crash", icon: "/icon/crash.svg", type: "EGAME" },
  { name: "Porker", icon: "/icon/sb.svg", type: "BINGO" },
  { name: "Fishing", icon: "/icon/fishing.svg", type: "FH" },
];

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };

      const endDate = new Date();
      const startDate = new Date();
      startDate.setDate(endDate.getDate() - 7);

      try {
        const [providersResponse, typesResponse] = await Promise.all([
          fetch(`${process.env.REACT_APP_API_URL}/api/get-provider`, { headers }),
          fetch(`${process.env.REACT_APP_API_URL}/api/get-type`, { headers }),
        ]);

        if (providersResponse.ok && typesResponse.ok) {
          const providersData = await providersResponse.json();
          const typesData = await typesResponse.json();
          setProviders(providersData.data || []);
          setGameTypes(typesData.types || []);
        }

        
        const [recordsResponse, exchangeResponse] = await Promise.all([
          fetch(`${process.env.REACT_APP_API_URL}/api/betting-record`, { headers }),
          fetch(`${process.env.REACT_APP_API_URL}/api/exchange-hub`, { headers }),
        ]);

        let filteredBets = [];
        let filteredExchanges = [];

        if (recordsResponse.ok) {
          const recordsData = await recordsResponse.json();
          filteredBets = (recordsData || []).filter((item) => {
            const created = new Date(item.created_at);
            return created >= startDate && created <= endDate;
          });
          setBettingRecords(filteredBets);
         
        }

        if (exchangeResponse.ok) {
          const exchangeData = await exchangeResponse.json();
          filteredExchanges = (exchangeData.data || []).filter((item) => {
            const created = new Date(item.created_at);
            return created >= startDate && created <= endDate;
          });
          setExchangeRecords(filteredExchanges);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

useEffect(() => {
  let result = [];

  if (!selected || !selected.type) {
    setFilteredRecords([]);
    return;
  }

  if (selected.type === "ALL") {
    result = [...bettingRecords, ...exchangeRecords];
  } else if (selected.type === "EXCHANGE") {
    result = exchangeRecords;
  } else {
    result = bettingRecords.filter((rec) => {
      const type = (rec?.game_type || "").toLowerCase();
      return type === selected.type.toLowerCase();
    });
  }

  setFilteredRecords(result);
}, [selected, bettingRecords, exchangeRecords]);



  useEffect(() => {
    let totalBetAmount = 0;
    let totalWinAmount = 0;
    let totalBets = 0;

    filteredRecords.forEach((record) => {
      const bet = Number(
        record.bet_amount || record.potential_liability || 0
      );
      const win = Number(
        record.winAmount ||
          (record.status === "won" ? record.potential_profit || 0 : 0)
      );

      totalBetAmount += bet;
      totalWinAmount += win;
      totalBets += 1;
    });

    const netProfitLoss = totalWinAmount - totalBetAmount;

    setSummary({
      totalBets,
      totalBetAmount,
      totalWinAmount,
      netProfitLoss,
    });
  
  }, [filteredRecords]);
  
    return(
        <div className="v-application--wrap">
  <div>
    {/**/}
    <div className="row no-gutters">
      <Header/>
    </div>
      <div className="body">
  <div style={{overflow: 'hidden'}}>
    <div className="row hidden-md-and-up" style={{height: '75px'}}>
      <div className="mobile-header text-center white--text col col-12">
        History
      </div>
    </div>
    
    <div className="row">
      <div className="historyContainer col col-12">
        <div>
          <div className="row bet-filter-card-wrapper hidden-md-and-up no-gutters">
            <div className="d-flex wrapper-col col col-12">
              {menus.map((menu) => (
          <div key={menu.type} onClick={() => setSelected(menu)}>
            <div
              tabIndex={0}
              className={`game-menu-content v-card v-card--link v-sheet theme--dark ${
                selected.type === menu.type ? "selected" : ""
              }`}
            >
              <div
                className={`toStatus-card-image mx-auto ${
                  selected.type === menu.type ? "selected" : ""
                }`}
                style={{ "--src": `url("${menu.icon}")` }}
              >
                <img src={menu.icon} alt={menu.name} />
              </div>
              <div className="game-menu-title">{menu.name}</div>
            </div>
          </div>
        ))}
              
            
           
            
        
         
              
            </div>
          </div>
          <div className="desktop_card v-card v-sheet theme--dark elevation-0">
           
            <div className="history-card v-card v-sheet theme--light elevation-0">
              <div className="row no-gutters">
                <div className="col col-12">
                  <div className="row">
                    <div className="pt-4 pb-2 px-4 date-padding col col-12">
                      <div className="v-input date-search-mobile mb-3 elevation-0 text-center v-input--hide-details v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined">
                        <div className="v-input__control">
                          <div className="v-input__slot">
                            <fieldset aria-hidden="true">
                              <legend style={{width: '0px'}}><span className="notranslate">​</span></legend>
                            </fieldset>
                            <div className="v-text-field__slot"><input id="input-903" type="text" /></div>
                            <div className="v-input__append-inner">
                              <div className="v-input__icon v-input__icon--clear"><button type="button" aria-label="clear icon" className="v-icon notranslate v-icon--link mdi mdi-close theme--light" /></div>
                            </div>
                            <div className="v-input__append-inner">
                              <div className="v-input__icon v-input__icon--append"><i aria-hidden="true" className="v-icon notranslate material-icons theme--light">search</i></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="v-menu" />
                    </div>
                    
                  </div>
                  
                {selected.type === 'ALL' ? (
  <div className="row mobile-history-table">
    <div className="mr-0 col col-6">
      <div className="row referral-table-header pl-6 no-gutters">
        <div className="col col-12">Date</div>
        <div className="col col-12">Bet Count</div>
        <div className="col col-12">Bet Amount</div>
        <div className="col col-12">Win lose</div>
        <div className="col col-12">Jackpot Contribution</div>
        <div className="col col-12">Jackpot Amount</div>
      </div>
    </div>
    <div className="col col-6">
      <div className="row no-gutters">
        <div className="col col-12">{new Date().toISOString().split("T")[0]}</div>
        <div className="col col-12">{summary.totalBets}</div>
        <div className="col col-12">৳ {summary.totalBetAmount.toFixed(2)}</div>
        <div className="col col-12">৳ {summary.totalWinAmount.toFixed(2)}</div>
        <div className="col col-12">৳ 0.00</div>
        <div className="col col-12">৳ 0.00</div>
      </div>
    </div>
    <div className="col col-12">
      <hr
        role="separator"
        aria-orientation="horizontal"
        className="mx-2 v-divider theme--light"
      />
    </div>
  </div>
) : (
  filteredRecords.map((r, i) => (
    <div key={i} className="row mobile-history-table">
      <div className="mr-0 col col-6">
        <div className="row referral-table-header pl-6 no-gutters">
          <div className="col col-12">Date</div>
          <div className="col col-12">Id</div>
          <div className="col col-12">Bet Id</div>
          <div className="col col-12">Provider</div>
          <div className="col col-12">Game Name</div>
          <div className="col col-12">Market</div>
          <div className="col col-12">Odds</div>
          <div className="col col-12">Bet Amount</div>
          <div className="col col-12">Valid Bet</div>
          <div className="col col-12">Win/Loss</div>
          <div className="col col-12">Tip</div>
          <div className="col col-12">Jackpot Contribution</div>
          <div className="col col-12">Jackpot Amount</div>
        </div>
      </div>

       <div className="col col-6">
        <div className="row no-gutters">
          <div className="col col-12">{r.created_at}</div>
          <div className="col col-12">{r.id || r.id}</div>
          <div className="col col-12">{r.platform_tx_id || r.transaction_id}</div>
          <div className="col col-12">{r.provider || r.sportName || "-"}</div>
          <div className="col col-12">{r.game_name || r.selection_name}</div>
          <div className="col col-12">{r.market || r.bet_type || r.marketType || (selected.type === 'EXCHANGE' ? 'Exchange' : '-')}</div>
          <div className="col col-12">{r.odds || r.backOdds || r.layOdds || r.price || '-'}</div>
          <div className="col col-12">৳ {r.bet_amount || r.potential_liability}</div>
          <div className="col col-12">৳ {r.bet_amount || r.stake || 0}</div>
          {(() => {
            const profit = r.winAmount
              ? Number(r.winAmount)
              : r.status === 'won'
              ? Number(r.potential_profit || 0)
              : Number(r.net_profit || 0);
            const cls = profit > 0 ? 'green--text' : profit < 0 ? 'red--text' : '';
            return (
              <div className={`col col-12 ${cls}`}>৳ {profit.toFixed(2)}</div>
            );
          })()}
          <div className="col col-12">৳ 0.00</div>
          <div className="col col-12">৳ 0.00</div>
          <div className="col col-12">৳ 0.00</div>
        </div>
      </div>
      <div className="col col-12">
        <hr
          role="separator"
          aria-orientation="horizontal"
          className="mx-2 v-divider theme--light"
        />
      </div>
    </div>
  ))
)}

               
                 
               
                
              
                
               
             
                 
                 
                </div>
              </div>
              <div className="row">{/**/}</div>
            </div>
           
          </div>
        </div>
      </div>
    </div>
  </div>
  {/**/}
</div>

    <Toolbar/>
    <Chat/>
  </div>
</div>

    );

}
export default BettingRecord;